import { axiosInstance } from '../request';
export const getPushPublicKey = async () => {
    const response = await axiosInstance.get('/api/v1/push/public-key');
    return response.data;
};
export const subscribePush = async (payload) => {
    await axiosInstance.post('/api/v1/push/subscribe', payload);
};
export const unsubscribePush = async (payload) => {
    await axiosInstance.post('/api/v1/push/unsubscribe', payload);
};
export const sendPush = async (payload) => {
    await axiosInstance.post('/api/v1/push/notify', payload);
};
//# sourceMappingURL=push.api.js.map